module.exports = __webpack_public_path__ + "static/media/icon-user.d2e7584e.svg";